export default "__VITE_ASSET__RCy_rmxn__"